import { createApiSlice } from "@common/common-slice/commonSlice";

import { CRUD_DIFFICULTY_LEVEL } from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addDifficultyLevel",
    method: "post",
    url: CRUD_DIFFICULTY_LEVEL,
    stateKey: "message",
  },
  {
    name: "updateDifficultyLevel",
    method: "put",
    url: CRUD_DIFFICULTY_LEVEL,
    stateKey: "message",
  },
  {
    name: "deleteDifficultyLevel",
    method: "delete",
    url: CRUD_DIFFICULTY_LEVEL,
    stateKey: "message",
  },
  {
    name: "getDifficultyLevel",
    method: "get",
    url: CRUD_DIFFICULTY_LEVEL,
    stateKey: "data",
  },
];

const customReducers = {
  initialState: {
    additionalData: [],
    details: [],
  },
  reducers: {
  },
};

const { slice, thunks, actions } = createApiSlice(
  "difficultyLevel",
  apiConfig,
  customReducers
);
const difficultyLevelSlice = slice;
export default difficultyLevelSlice.reducer;

export const actionsExports = actions;

export const {
  addDifficultyLevel,
  updateDifficultyLevel,
  deleteDifficultyLevel,
  getDifficultyLevel,
} = thunks;

export const { rowSelect } =
  actionsExports;
